/* Count each statistic once on entering the viewport; final values remain accessible. */
class WoodLasAboutStats extends HTMLElement {
  connectedCallback() {
    if (this.controller) return;
    this.controller = new AbortController();
    this.motion = matchMedia('(prefers-reduced-motion: reduce)');
    this.entries = [...this.querySelectorAll('[data-stat-value]')].map(node => {
      const final = node.dataset.statValue;
      const match = final.match(/^(\D*?)(\d[\d,]*(?:\.\d+)?)(.*)$/);
      return { node, final, match, frame: 0, done: false };
    });
    const finish = entry => {
      cancelAnimationFrame(entry.frame);
      entry.node.textContent = entry.final;
      entry.done = true;
    };
    this.motion.addEventListener('change', () => {
      if (this.motion.matches) {
        this.entries.forEach(finish);
        this.observer?.disconnect();
      }
    }, { signal: this.controller.signal });
    if (this.motion.matches || !('IntersectionObserver' in window)) {
      this.entries.forEach(finish);
      return;
    }
    this.observer = new IntersectionObserver(items => {
      items.forEach(item => {
        if (!item.isIntersecting) return;
        const entry = this.entries.find(entry => entry.node === item.target);
        this.observer.unobserve(item.target);
        if (!entry || entry.done || !entry.match) return;
        entry.done = true;
        const [, prefix, digits, suffix] = entry.match;
        const target = Number(digits.replaceAll(',', ''));
        const decimals = (digits.split('.')[1] || '').length;
        const format = value => digits.includes(',')
          ? value.toLocaleString('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals })
          : value.toFixed(decimals);
        let start;
        const tick = time => {
          if (start === undefined) start = time;
          const progress = Math.min((time - start) / 1600, 1);
          const value = target * (1 - Math.pow(1 - progress, 3));
          entry.node.textContent = prefix + format(decimals ? value : Math.floor(value)) + suffix;
          if (progress < 1) entry.frame = requestAnimationFrame(tick);
          else finish(entry);
        };
        entry.frame = requestAnimationFrame(tick);
      });
    }, { threshold: 0.6 });
    this.entries.forEach(entry => {
      if (!entry.match) return;
      entry.node.textContent = entry.match[1] + '0' + entry.match[3];
      this.observer.observe(entry.node);
    });
  }

  disconnectedCallback() {
    this.entries?.forEach(entry => {
      cancelAnimationFrame(entry.frame);
      entry.node.textContent = entry.final;
    });
    this.observer?.disconnect();
    this.controller?.abort();
    this.controller = null;
  }
}
if (!customElements.get('woodlas-about-stats')) customElements.define('woodlas-about-stats', WoodLasAboutStats);
